import * as firebase from 'firebase'
import 'firebase/firestore'

firebase.initializeApp({
  apiKey: 'AIzaSyBQt-_6rnxKlc9XFUekjudZNpcRIHrNCMo',
  authDomain: 'vusik-type.firebaseapp.com',
  databaseURL: 'https://vusik-type.firebaseio.com',
  projectId: 'vusik-type',
  storageBucket: 'vusik-type.appspot.com',
  messagingSenderId: '673685039908'
})



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/firebase.ts